import clientSettingsClient from '@modules/clients/clientSettingsClient';
import { getStudioBinaryType } from '@modules/ui/shared/utils/studioHelper';
import { createStudioResources } from '@rbx/studio';
import { getRobloxDomain, getRobloxEnvironment } from '@modules/utilities/constants/baseUrl';
import throwError from '@modules/utilities/error';
import { ThemeMode } from '@rbx/ui';

export const studioLogoSvg = {
  light: `https://cdn.foundation.${getRobloxDomain()}/current/StudioLogo-Light.svg`,
  dark: `https://cdn.foundation.${getRobloxDomain()}/current/StudioLogo-Dark.svg`,
} as const;

export const createStudioResourcesWithTheme = (themeMode: ThemeMode) =>
  createStudioResources({
    logoSrc: studioLogoSvg[themeMode],
    target: process.env.buildTarget,
    environment: getRobloxEnvironment(),
    fetchers: {
      userChannel: async () => {
        const channelName = await clientSettingsClient.getUserChannel(getStudioBinaryType());
        return channelName?.toUpperCase() !== 'LIVE' ? channelName : '';
      },
    },
    errorHandler: (error: Error) => {
      throwError(`StudioResourcesProvider error: ${error.message}`);
    },
  });
